import { render } from "./PointComponent.vue?vue&type=template&id=d0699b92&scoped=true"
import script from "./PointComponent.vue?vue&type=script&lang=js"
export * from "./PointComponent.vue?vue&type=script&lang=js"

import "./PointComponent.vue?vue&type=style&index=0&id=d0699b92&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0699b92"]])

export default __exports__